import styled from 'styled-components'

export const StyledLink = styled.a<{ color?: string; size?: string; margin?: string }>`
  text-decoration: none;
  color: ${({ color, theme }) => color || theme.color.black};
  font-size: ${({ size, theme }) => size || theme.font.size.md};
  margin: ${({ margin }) => margin || 0};
`
